export function toBoolean(val: unknown): boolean {
  return val === true || val === 'true';
}
